// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"13c16127","319":"fc12d7fb","387":"6aa001e0","437":"f2b9d118","510":"d93b0a9f","560":"a9dcb8bf","678":"8c6ff7d4","723":"a9120693","817":"0d6b79f9","924":"ab87a5fd","974":"20ba69a3"}[chunkId] + ".chunk.js";
};